import {SET_QUIZ, SET_QUESTION, VALIDATE_QUESTION, SET_RESPONSE_SCORE} from '../types'
import Api from '@/api/api'
import Vue from 'vue'
import * as api from '@/api/quizApi'

const state = {
  quiz: [],
  question: {},
  introduction: {},
  conclusion: {},
  score: null,
  minScore: null,
  showresult: false,
  showanswer: false
}

const mutations = {
  [SET_QUIZ] (state, data) {
    let datas = data.questions || []
    let length = datas.length
    for (let i = 0; i < length; i++) {
      Vue.set(datas[i], 'validated', false)
      if (datas[i].propositions) {
        let pl = datas[i].propositions.length
        for (let j = 0; j < pl; j++) {
          if (datas[i].type === 'text') {
            Vue.set(datas[i].propositions[j], 'selected', '')
          } else {
            Vue.set(datas[i].propositions[j], 'selected', false)
          }
        }
      }
    }
    state.showresult = data.showresult
    state.showanswer = data.showanswer
    state.quiz = datas
    state.introduction = data.introduction
    state.conclusion = data.conclusion
    if (data.min_percent_score) {
      state.minScore = data.min_percent_score
    }
  },
  [SET_QUESTION] (state, data) {
    let i = parseInt(data) - 1
    state.question = state.quiz[i]
  },
  [VALIDATE_QUESTION] (state, data) {
    state.quiz[data].validated = true
  },
  [SET_RESPONSE_SCORE] (state, data) {
    state.score = data
  }
}

const getters = {
  quiz () {
    return state.quiz
  },
  introduction () {
    return state.introduction
  },
  conclusion () {
    return state.conclusion
  },
  showResult () {
    return state.showresult
  },
  showAnswer () {
    return state.showanswer
  },
  questionEnCours () {
    return state.question
  },
  lastQuestion () {
    return state.quiz.length
  },
  getMinScore () {
    return state.minScore
  },
  getScore () {
    return state.score
  }
}

const actions = {
  getQuiz: (store, vue) => {
    return Api.action(vue, api.getquiz, {
      slug: vue.$route.params.slug,
      options: {fullLoader: true}
    }).then((response) => {
      store.commit(SET_QUIZ, response.data)
      store.commit(SET_QUESTION, 1)
    })
  },
  setQuizResults: (store, vue, options) => {
    return Api.action(vue, api.setresults, {
      post: {
        data: state.quiz,
        query: vue.$route.query,
        slug: vue.$route.params.slug
      },
      options: {}
    }).then((response) => {
      store.commit(SET_RESPONSE_SCORE, response.data.score)
    })
  },
  getQuestion: (store, vue) => {
    if (state.quiz.length === 0) {
      store.commit(SET_QUESTION, 1)
    }
    store.commit(SET_QUESTION, vue.$route.params.question)
  },
  validateQuestion: (store, question) => {
    store.commit(VALIDATE_QUESTION, question)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/quiz.js